<!-- The countdown to the next session; during the warm-up hour before it (isLink), the same
     countdown is a pill linking to /live, where the platform check is already open -->
<template>
  <router-link v-if="isLink" class="cta-pill countdownLink" :to="{name: 'Live'}">
    {{ timerText }}
  </router-link>
  <span v-else class="countdown">{{ timerText }}</span>
</template>

<script setup>
import {computed, inject} from "vue";
import {Duration} from "luxon";

const props = defineProps({
  start: {type: Object, required: true},
  now: {type: Object, required: true},
  isLink: {type: Boolean, default: false}
});
const displayWidth = inject("displayWidth");

function pad(value) {
  return String(value).padStart(2, "0");
}

// from the milliseconds between them: a calendar diff counts days in the zones' wall clocks, so
// it was a day out whenever the browser's date differed from London's (e.g. Australia)
function getParts(start, now) {
  const duration = Duration.fromMillis(start.toMillis() - now.toMillis());
  const diff = duration.shiftTo("days", "hours", "minutes", "seconds").toObject();
  const [days, hours, minutes, seconds] = [diff.days, diff.hours, diff.minutes, diff.seconds];
  return [days, hours, minutes, seconds].map((part) => Math.max(0, Math.floor(part || 0)));
}

// narrow screens drop seconds until under an hour remains
function formatCountdown(start, now, isNarrow) {
  const [days, hours, minutes, seconds] = getParts(start, now);
  const secondsText = isNarrow ? "" : ` ${pad(seconds)}s`;
  if (days > 0) return `${days}d ${pad(hours)}h ${pad(minutes)}m${secondsText}`;
  if (hours > 0) return `${pad(hours)}h ${pad(minutes)}m${secondsText}`;
  if (minutes > 0) return `${pad(minutes)}m ${pad(seconds)}s`;
  return `${pad(seconds)}s`;
}

const timerText = computed(() => {
  return formatCountdown(props.start, props.now, displayWidth.value === "narrow");
});
</script>

<style src="./pill.css"></style>

<style scoped>
.countdownLink {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
/* distinctly quieter than the side labels (Seán, 2026-10-22): regular weight, smaller, a mid
   grey (fixed: the banner is black in both modes; 7.4:1 on black); Nunito Sans's digits are all
   one width, so it doesn't shift as it counts */
.countdown {
  white-space: nowrap;
  color: #9aa0a6;
  font-size: 0.85em;
  font-weight: normal;
  font-variant-numeric: tabular-nums;
}
</style>
